import styled, { createGlobalStyle, css } from 'styled-components';
import { slideIn, slideOut, initialSlide, fadeIn, fadeOut } from './keyframes.js';
import Button from '../Button/Button.js';
import { Tooltip } from '../Tooltip/Tooltip.js';

const sideNavTransitionProperties = '300ms ease-in-out';
const sideNavAnimationProperties = `${sideNavTransitionProperties} forwards`;
const Container = styled.div `
  position: relative;
`;
const BodyMargin = createGlobalStyle(({ theme: { olist: { breakpoints }, }, }) => css `
    body {
      transition: margin-left ${sideNavTransitionProperties};
      margin-left: 88px !important;

      @media (max-width: ${breakpoints.small}) {
        margin-left: 0 !important;
      }
    }
  `);
const MobileTriggerButton = styled(Button)(({ theme, insideGrid }) => css `
    position: absolute;
    top: 20px;
    left: ${insideGrid ? 0 : theme.olist.spacing.inline.small};

    display: block;

    @media (min-width: ${theme.olist.breakpoints.small}) {
      display: none;
    }
  `);
const Wrapper = styled.aside(({ theme, isSideNavExpanded, startAnimation }) => {
    const { olist: { breakpoints, color, spacing }, } = theme;
    return css `
      position: fixed;
      top: 0;
      left: 0;

      width: 292px;
      box-shadow: rgb(0 0 0 / 50%) 0px 10000px 0px 10000px;
      height: 100vh;

      margin-top: 0;

      padding-inline: ${spacing.inline.small};
      padding-top: ${spacing.stack.small};
      padding-bottom: ${spacing.stack.large};

      display: ${isSideNavExpanded ? 'flex' : 'none'};
      flex-direction: column;
      align-items: center;

      background-color: ${color.neutral.softest};

      box-sizing: border-box;
      overflow-x: hidden;
      overflow-y: auto;
      z-index: 8000;

      @media (min-width: ${breakpoints.small}) {
        width: ${isSideNavExpanded ? '360px' : '88px'};
        box-shadow: none;
        border-right: 1px solid ${color.neutral.soft};
        display: flex;

        animation: ${startAnimation
        ? css `
              ${isSideNavExpanded
            ? slideIn
            : slideOut} ${sideNavAnimationProperties}
            `
        : 'none'};
      }

      @media (min-width: ${breakpoints.small}) {
        animation: ${startAnimation
        ? css `
              ${isSideNavExpanded
            ? slideIn
            : slideOut} ${sideNavAnimationProperties}
            `
        : css `
              ${initialSlide(theme)} ${sideNavAnimationProperties}
            `};
      }
    `;
});
const WrapperLogo = styled.div(({ isSideNavVisible }) => css `
    position: relative;
    width: 100%;
    height: 48px;
    display: flex;
    align-items: center;
    justify-content: ${isSideNavVisible ? 'space-between' : 'center'};
    flex-shrink: 0;
  `);
const StyledTooltip = styled(Tooltip) `
  z-index: 9999;
`;
const LogoLink = styled.a(({ isSideNavVisible, isClosing, theme }) => css `
    opacity: 1;
    transition: opacity ${sideNavTransitionProperties};

    &:focus-visible {
      outline: none;
      border-radius: ${theme.olist.borderRadius['1xsmall']};
      box-shadow: 0 0 0 1px ${theme.olist.color.neutral.softest},
        0 0 0 3px ${theme.olist.color.neutral.strong};
    }

    ${isSideNavVisible &&
    css `
      animation: ${fadeIn} ${sideNavAnimationProperties};
    `}

    ${isClosing &&
    css `
      animation: ${fadeOut} ${sideNavAnimationProperties};
    `}
  `);

export { BodyMargin, Container, LogoLink, MobileTriggerButton, StyledTooltip, Wrapper, WrapperLogo, sideNavAnimationProperties, sideNavTransitionProperties };
